import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoiceMid: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="voice-mid, wave"><path d="M7.75 5.75V18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 10.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 9.75V14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.25 7.75V16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 10.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVoiceMid;
